import React from 'react';
import { is } from '../../../services';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * ChipsList Component - Container for Chips
 * @param children {React.ReactNode}
 * @param multiple {boolean} Selection Multiple With checked icon
 * @param className {string} Additionnal CSS Classes
 */
const ChipsList = ({ children, multiple, className, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('chips-list', multiple && is('multiple'), className));
    return (React.createElement("div", { className: classes, ...others }, children));
};
export default ChipsList;
//# sourceMappingURL=ChipsList.js.map